
import routes from './routes.js';
import { Routes, Route } from "react-router-dom";

function App() {
  return (
    <div style={{
      display:'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      minHeight: '100%',
      minWidth: '100%'
    }}>
      <Routes>
        {routes.map((prop, key) => {
          return <Route path={prop.path} element={prop.element} key={key} />;
        })}
      </Routes>
    </div>
  );
}

export default App;
